import { createRouter, createWebHistory } from 'vue-router'
// import { beforeEach } from './interceptor'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes
})

if (window.addCollabRouter) {
  window.addCollabRouter(router)
}
router.afterEach((to) => {
  if (window.propagateToMain) {
    window.propagateToMain(to.fullPath)
  }
})

// router.beforeResolve(beforeEach)
export default router
